import { useField, useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";

import {
  CLUB_TAGS_MAX_LENGTH,
  MAX_TAG_LENGTH,
} from "../../../../common/constants/clubs-wizard.constants";
import { MAX_TAGS_ALLOWED } from "../../../../common/constants/common.constants";
import { ICreateClubWizardForm } from "../../../../common/interfaces/clubs-wizard.interface";
import { IOption } from "../../../../common/interfaces/common.interface";
import { slugify } from "../../../../utilities/helpers";
import WizardField from "../../../WizardField/WizardField";

import "./ClubTags.scss";

//TODO @goran:Get these two arrays from backend
const DUMMY_TAGS: IOption[] = [
  { label: "NFT", value: "nft" },
  { label: "Web 3.0", value: "web-3.0" },
  { label: "Decentralized", value: "decentralized" },
];

const DUMMY_OPTIONS: IOption[] = [
  { label: "NFT", value: "nft" },
  { label: "Monkey DAO", value: "monkey-dao" },
];

const ClubTags: FC = ({}) => {
  const [highlightedTags, setHighlightedTags] = useState<IOption[]>([]);
  const { setFieldValue, values, setFieldError } =
    useFormikContext<ICreateClubWizardForm>();
  const [field, meta] = useField("clubTags");
  const [tags, setTags] = useState<Array<IOption>>(values.clubTags);
  const [noOptionsMessage, setNoOptionsMessage] = useState<string>();

  useEffect(() => {
    let newHighlightTags = DUMMY_TAGS;
    DUMMY_TAGS.forEach((item) => {
      if (values.clubTags.find((valueItem) => item.label === valueItem.label)) {
        newHighlightTags = newHighlightTags.filter(
          (tag) => tag.label !== item.label
        );
      }
    });

    setHighlightedTags(newHighlightTags);
  }, [values.clubTags]);

  const addNewTagHandler = (e: any) => {
    if (e.length === MAX_TAGS_ALLOWED) {
      setFieldError("clubTags", "Maximum of 8 tags is allowed");
      return;
    }
    const slugTags: IOption[] = slugify(e);
    setTags(Array.from(e));
    setFieldValue("clubTags", slugTags);
  };

  const validateNewTag = (e: any) => {
    const isValid =
      e.length <= MAX_TAG_LENGTH && tags.length < CLUB_TAGS_MAX_LENGTH;
    if (e.length > MAX_TAG_LENGTH) {
      setNoOptionsMessage("Maximum tag length is 21 character");
    } else {
      setNoOptionsMessage(e.length > 0 ? "Create: " + e : "No options");
    }
    return isValid;
  };

  return (
    <div className="club-tags">
      <WizardField
        placeholder="Enter tags here"
        type="creatable-select"
        selectOptions={DUMMY_OPTIONS}
        values={tags}
        onChange={(e: any) => addNewTagHandler(e)}
        isValidField={(e) => validateNewTag(e)}
        name="clubTags"
        label="Club tags"
        noOptionsMessage={noOptionsMessage}
      />
      {meta.error && <p className="input__error">{meta.error}</p>}
      <p className="club-tags__description">
        Add of create tags that best describe your club.
      </p>
    </div>
  );
};

export default ClubTags;
